import { CustomerTable } from "../../../../../../Common/CustomTable";

const BillDetailPage = ({ data ,payment}) => {
    function formatToISTWithAmPm(utcString) {
        const date = new Date(utcString);
      
        // Convert to IST (UTC + 5.5 hours)
        const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
      
        const day = String(istDate.getDate()).padStart(2, '0');
        const month = String(istDate.getMonth() + 1).padStart(2, '0');
        const year = istDate.getFullYear();
      
        let hours = istDate.getHours();
        const minutes = String(istDate.getMinutes()).padStart(2, '0');
      
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours === 0 ? 12 : hours; // Convert '0' to '12'
      
        const hoursFormatted = String(hours).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hoursFormatted}:${minutes} ${ampm}`;
      }
      
    const roomInfo = [
        {
            RoomNumber: data?.reservation?.rooms?.map(item => item.room_number).join(', ') || "N/A",
            GuestName: `${data?.guest?.first_name} ${data?.guest?.last_name}`,
            CheckInDate: formatToISTWithAmPm(data?.reservation?.check_in_date_time),
            CheckOutDate: formatToISTWithAmPm(data?.reservation?.check_in_date_time),
            TotalBill: `₹${payment?.grandTotal}`,
        },
    ];

    return (
        <div className="col-md-12">
            <div className="card">
                <div className="card-header">
                    <h6 className="card-title">Billing Details</h6>
                </div>
                <div className="card-body">
                    <CustomerTable guestInfo={roomInfo} />
                </div>
            </div>
        </div>
    );
};

export default BillDetailPage;
